import { useState } from "react";
import { PauseCircle, PlayCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export const AdminSuspendButton = ({ restaurant, onToggled }) => {
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/restaurants/${restaurant.id}/suspend`);
      onToggled(restaurant.id, data.suspended);
      toast.success(data.suspended ? `${restaurant.name} sospeso: menù nascosto` : `${restaurant.name} riattivato`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Operazione non riuscita");
    } finally {
      setBusy(false);
    }
  };
  const s = restaurant.suspended;
  return (
    <Button variant="ghost" size="sm" onClick={toggle} disabled={busy} title={s ? "Riattiva account" : "Sospendi account"}
      className={s ? "text-[#4a8a56] hover:bg-[#5aa469]/10" : "text-amber-600 hover:bg-amber-50"} data-testid={`admin-suspend-${restaurant.id}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : s ? <PlayCircle className="h-4 w-4" /> : <PauseCircle className="h-4 w-4" />}
    </Button>
  );
};
